import { useCallback, useState } from 'react';

export const useDescopeFlow = () => {
  const [flowKey, setFlowKey] = useState(0);
  const [isFlowLoading, setIsFlowLoading] = useState(true);

  const onReady = useCallback(() => {
    setIsFlowLoading(false);
  }, []);

  const resetFlow = useCallback(() => {
    setIsFlowLoading(true);
    setFlowKey(prev => prev + 1);
  }, []);

  return {
    flowKey,
    isFlowLoading,
    onReady,
    resetFlow,
  };
};
